import angular from 'angular';
import ngResource from 'angular-resource';
import apiSuppliersConfig from 'json!../../../config/api-suppliers.json';

class ApiTransfersService {
    constructor($resource, $http, $translate) {
      'ngInject';
      this.$http = $http;
      this.transfersBySupplierAndGateway = $resource(apiSuppliersConfig.baseUrl + apiSuppliersConfig.endpoint.transfersBySupplierAndGateway, {
        'suppliers': '@suppliers',
        'gateways': '@gateways',
        'init_date': 'init_date',
        'end_date': 'end_date',
        'has_only_ratecards_for_shuttles': 'has_only_ratecards_for_shuttles',
        'force_from_hotel_to_airport': 'force_from_hotel_to_airport'
      }, {
        get: {
          method: "GET", headers: {
            "Accept-Language": $translate.use()
          }
        }
      });

      this.gatewaysBySupplier = $resource(apiSuppliersConfig.baseUrl + apiSuppliersConfig.endpoint.gatewaysBySupplier, {
        'suppliers': '@suppliers'
      }, {
        get: {
          method: "GET",
          headers: {
            "Accept-Language": $translate.use()
          }
        }
      });

      this.downloadTransfersExcel = $resource(apiSuppliersConfig.baseUrl + apiSuppliersConfig.endpoint.downloadTransfersExcel, {
        'suppliers': '@suppliers',
        'gateways': '@gateways',
        'init_date': 'init_date',
        'end_date': 'end_date'
      }, {
        get: {
          method: "GET",
          responseType: 'arraybuffer',
          headers: {
            "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Accept-Language": $translate.use()
          }
        }
      });
    }

    saveTransfers(data) {
        let status = {
            'success': 1,
            'error': 0
        }
        return this.$http.patch(apiSuppliersConfig.baseUrl + apiSuppliersConfig.endpoint.transfers, data).then((response) => {
            if (response.status === 204) {
                return null;
            }
            let transfersStatus = response.data.items.reduce(function(items, item) {
                items[item.index] = status[item.status];
                return items;
            }, {});
            return transfersStatus;
        });
    }
}

const apiTransfersModule = angular.module('api.suppliers.transfers', [
        ngResource
    ])
    .service('apiTransfersService', ApiTransfersService)
    .name;

export default apiTransfersModule;



// WEBPACK FOOTER //
// ./client/app/api/transfers.service.js